const BE_ENDPOINT =  "/api"; // "http://127.0.0.1:8383"; //       via proxy server for prod //     "http://192.168.50.124:8383"; // for playlists

export class SongService {

    getSongs() {
        return fetch(BE_ENDPOINT + '/playlists/supported_tracks_nameconcat').then(res => res.json());
    }

    getAlbums() {
        return fetch(BE_ENDPOINT + '/playlists/supported_albums_nameconcat').then(res => res.json());
    }

    generatePlaylist(playlist_info, pl_gen_method, pl_gen_delta_song){
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',})
        return fetch(BE_ENDPOINT+'/playlists/generate_playlist/' + pl_gen_method.id + '/' + pl_gen_delta_song,  {
            method: 'post',
            body: JSON.stringify(playlist_info),
            headers: headers,
        }).then(res => res.json());
    }

    generatePlaylistV2(tracks, pl_gen_params, pl_filler_params){
        let data = {
            tracks: tracks,
            generator: pl_gen_params,
            filler_def: pl_filler_params,
        };
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',})
        // body: tracks: list[TrackFE],
        // generator: PlaylistGeneratorParams:
        //     pl_gen_method: str
        //     delta_song: int
        // filler_def: PlaylistFillerDefinition:
        // max_duration_ms: int # 2min30 - 10min
        //     exclude_skit: bool
        //     nr_songs_by_member: int
        //     minimum_nr_songs_bts: int
        return fetch(BE_ENDPOINT+'/playlists/generate_playlist',  {
            method: 'post',
            body: JSON.stringify(data),
            headers: headers,
        }).then(res => res.json());
    }

    getSupportedArtists(){
        return fetch(BE_ENDPOINT+'/playlists/supported_artists')
            .then(res => res.json());
    }


    // if spotifyplaylist_id is given, trying to edit
    savePlaylist(playlistDef, access_token, spotifyuser_id, edit=false, spotifyplaylist_id = "undefined") {

        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',})

        if(access_token !== null ) {
            headers.append('Authorization', `Bearer ${access_token}`);
            let data = {'playlistDef': playlistDef};
            if (spotifyuser_id !== null) {
                data['spotifyuser_id'] = spotifyuser_id;
            } else {
                data['spotifyuser_id'] = -1;
            }
            if (edit) {
                data['spotifyplaylist_id'] = spotifyplaylist_id;
                return fetch(BE_ENDPOINT + '/playlists/edit_playlist_spotify', {
                    method: 'post',
                    body: JSON.stringify(data),
                    headers: headers
                }).then(res => res);
            } else {
                data['spotifyplaylist_id'] = "undefined";
                return fetch(BE_ENDPOINT + '/playlists/save_playlist_spotify', {
                    method: 'post',
                    body: JSON.stringify(data),
                    headers: headers
                }).then(res => res);
            }
        } else {
            return fetch(BE_ENDPOINT + '/playlists/save_playlist_spotify_public', {
                method: 'post',
                body: JSON.stringify(playlistDef),
                headers: headers
            }).then(res => res);
        }
    }

    loadPlaylist(playlistId, access_token = null){
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',})

        if(playlistId !== null) {
            if(playlistId.includes("spotify.link")) {
                let encodedPL = {'url': playlistId};//"url=" +
                return fetch(BE_ENDPOINT + '/playlists/load_playlist_via_redirect', {
                            method: 'post',
                            body: JSON.stringify(encodedPL),
                            headers: headers
                }).then( res => res.json());
            }
            else {
                let playlistId_ = this.convertLinkToId(playlistId);
                if(playlistId.includes("apple") || playlistId_.startsWith("p")) {
                    return fetch (BE_ENDPOINT + '/am/load_playlist_applemusic/' + playlistId_)
                        .then(res => res.json());
                } else {
                    if(access_token === null || access_token === undefined) {
                        return fetch(BE_ENDPOINT + '/playlists/load_playlist_spotify/' + playlistId_)
                            .then(res => res.json());
                    } else {
                        headers.append('Authorization', `Bearer ${access_token}`);
                        return fetch(BE_ENDPOINT + '/playlists/load_playlist_spotify_for_editing/' + playlistId_,
                            {method: 'get', headers: headers})
                            .then(res => res.json());
                    }

                }

            }
        }
    }

    convertLinkToId(spotifyIdLink){
        let parts = spotifyIdLink.split('/');
        let last_part = parts[parts.length - 1];
        let id = last_part.split("?")[0]
        return id
    }
}

/*

https://www.reddit.com/r/reactjs/comments/sma7vy/how_to_create_a_react_app_that_connects_to_an_api/
// Make a new component 
const MyAPIComponent = ({url})=>{

  // we’re going to sync our state with the api 
  const data = useState()

  // use effect, no dependents b/c
  // we want this to run once then render 
  useEffect( ()=>{

    // arrow function that wraps our effect logic 
    const getAPIResource = async ()=> {
      // ideally you would add a try catch
      // we want to see errors to learn, so let it crash 

      // use browser fetch -> HTTP GET $url
     const _data = await fetch(url)

     // update state with our data (could be json)
     setData(_data.json())

    }

    // run effect once 
    if(!data) getAPIResource()

  },[])

  // render #1: data = undefined 
  // render #2: data = json 
  return(<pre>{JSON.stringify(data,null,2)}</pre>)
}

...
*/
// <>
   // {*/ pass url as prop, just an example of using props/*}
  // <MyAPIComponent url={"/api"} />
// </>

